import React from 'react'
import Layout from '../../components/Layout/Layout'

export default function PrivacyPolicy() {
    return (
        <Layout>
            <>
                <div className="bred_crumb blog_detail_bredcrumb">
                    <div className="container">
                        <div className="bred_text">
                            <h1>Privacy policy</h1>
                        </div>
                    </div>
                </div>
                <section className="blog_detail_section">
                    <div className="container">
                        <div className="blog_inner_pannel">
                            <div className="review">
                                <span>Effective Date: </span>
                                <span>12 December, 2024</span>
                            </div>
                            <div className="section_title">
                                <h2>Introduction</h2>
                            </div>
                            <div className="container">
                                <p>
                                    My Bilty, operated by Dizixpert Techno Services Pvt. Ltd., is
                                    committed to protecting the privacy of its users. This Privacy
                                    Policy outlines how we collect, use, store, and safeguard the
                                    personal and business information provided by users of the My Bilty
                                    Lorry Receipt Management System. By using My Bilty, you agree to the
                                    collection and use of your data as described in this policy.
                                </p>
                                <h2>1. Information We Collect</h2>
                                <p>
                                    We collect different types of information from users of the My Bilty
                                    platform, including:
                                </p>
                                <ul>
                                    <li>
                                        <strong>Personal Information:</strong>
                                        <ul>
                                            <li>Full Name</li>
                                            <li>Contact Information (Email address, Phone number)</li>
                                            <li>User Role (Super Admin, Transporter Admin, Driver)</li>
                                        </ul>
                                    </li>
                                    <li>
                                        <strong>Business Information:</strong>
                                        <ul>
                                            <li>Company Name</li>
                                            <li>Address and Contact Information</li>
                                            <li>Business Identification Numbers (e.g., GST number)</li>
                                        </ul>
                                    </li>
                                    <li>
                                        <strong>Transactional Information:</strong>
                                        <ul>
                                            <li>Details of Lorry Receipts (Bilty) issued or received</li>
                                            <li>Payment and Invoicing Information</li>
                                            <li>Account Management details</li>
                                        </ul>
                                    </li>
                                    <li>
                                        <strong>Device and Usage Information:</strong>
                                        <ul>
                                            <li>IP Address</li>
                                            <li>Browser type and version</li>
                                            <li>Device type and operating system</li>
                                            <li>Location data (based on device settings)</li>
                                        </ul>
                                    </li>
                                    <li>
                                        <strong>Communications:</strong>
                                        <ul>
                                            <li>
                                                Messages and other communications sent via the platform
                                                between Super Admins, Transporter Admins, and Drivers
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                                <h2>2. How We Use Your Information</h2>
                                <p>We use the collected information for the following purposes:</p>
                                <ul className="mb-3">
                                    <li>To provide and manage the My Bilty platform</li>
                                    <li>To process transactions</li>
                                    <li>To personalize your experience</li>
                                    <li>To communicate with you</li>
                                    <li>To ensure security</li>
                                </ul>
                                <h2>3. How We Protect Your Information</h2>
                                <p>
                                    We take the security of your personal and business information
                                    seriously. Measures include encryption, access controls, and regular
                                    audits.
                                </p>
                                <h2>4. Data Retention</h2>
                                <p>
                                    We retain your information as long as necessary for the purposes
                                    described in this policy and to fulfill legal obligations.
                                </p>
                                <h2>5. Sharing Your Information</h2>
                                <p>
                                    We do not sell or rent your data. Information may be shared with
                                    service providers, legal authorities, or in business transfers as
                                    necessary.
                                </p>
                                <h2>6. Your Data Rights</h2>
                                <ul className="mb-3">
                                    <li>Access</li>
                                    <li>Correction</li>
                                    <li>Deletion</li>
                                    <li>Opt-Out</li>
                                </ul>
                                <h2>7. Third-Party Links</h2>
                                <p>
                                    We are not responsible for the privacy practices of third-party
                                    websites linked from My Bilty.
                                </p>
                                <h2>8. Children's Privacy</h2>
                                <p>
                                    My Bilty is not intended for individuals under eighteen. If such
                                    data is collected, it will be deleted promptly.
                                </p>
                                <h2>9. Changes to This Privacy Policy</h2>
                                <p>
                                    We may update this Privacy Policy. Continued use of the platform
                                    indicates acceptance of changes.
                                </p>
                                <h2>10. Contact Us</h2>
                                <p className="mb-0">
                                    If you have any questions, please contact us at:
                                </p>
                                <p className="mb-0">Dizixpert Techno Services Pvt. Ltd.</p>
                                <p className="mb-0">
                                    Email:{" "}
                                    <a href="mailto:support@dizixpert.com">support@dizixpert.com</a>
                                </p>
                                <p className="mb-0">Phone: +91 9351111477</p>
                                <p className="mb-0">
                                    Address: Dizixpert Techno Services Pvt. Ltd., Sri Ganganagar Road,
                                    Jaipur Jodhpur By-Pass, Bikaner (Raj.) - 334001
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        </Layout>
    )
}
